import React, { Component } from 'react';
import TermsForm from './TermsForm';
import NavBar from '../NavBar/NavBar';
import './Terms.css';


class Terms extends Component {
  render () {
    return (
      <div className="TermsPage">
        <NavBar showLess={!localStorage.getItem("y_jwt_token")} />
        <TermsForm />
      </div>
    )
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms/Terms.js